import { ApiTab } from '@/Enums/Attribution/ApiTabs.enum';
import WebVisitsReportViewEnum from '@/Enums/Attribution/WebVisits/ReportView.enum';
import MapScale from '@/Enums/Map/MapScale.enum';
import { IMPRESSION_TYPE_LABELS } from './reporting';

export const API_TABS_BASE_TAB_ID = 'attribution-api-tabs';

export const API_TAB_LABEL: Record<ApiTab, string> = {
  [ApiTab.WebVisits]: 'Web Visits',
  [ApiTab.OfflineSales]: 'Offline Sales',
  [ApiTab.FootTraffic]: 'Foot Traffic',
};

export const AVG_IMPRESSION_CSV = 'Avg. Impression';

export const BEESWAX_IMPRESSION_TYPES = [
  WebVisitsReportViewEnum.Date,
  WebVisitsReportViewEnum.Channel,
  WebVisitsReportViewEnum.Device,
  WebVisitsReportViewEnum.Campaign,
  WebVisitsReportViewEnum.Placement,
  WebVisitsReportViewEnum.Pixel,
  WebVisitsReportViewEnum.Creative,
  WebVisitsReportViewEnum.Publisher,
  WebVisitsReportViewEnum.DaysOfWeek,
  WebVisitsReportViewEnum.Daypart,
].map(value => ({
  value,
  label: IMPRESSION_TYPE_LABELS[value],
}));

export const FILTERS_BASE_TAB_ID = 'attribution-filter-tab';

export const WEB_VISITS_BEESWAX_MAP_SCALES: ReadonlyArray<MapScale> = Object.values(MapScale);
